import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { initLenis, scrollToTarget, scrollToTop } from "@/lib/scroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Committees from "@/pages/Committees";
import Schedule from "@/pages/Schedule";
import GalleryPage from "@/pages/GalleryPage";

const ScrollManager = () => {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const t = setTimeout(() => scrollToTarget(location.hash), 150);
            return () => clearTimeout(t);
        }
        scrollToTop();
    }, [location.pathname, location.hash]);
    return null;
};

function App() {
    useEffect(() => {
        initLenis();
    }, []);

    return (
        <MotionConfig reducedMotion="user">
            <BrowserRouter>
                <ScrollManager />
                <div className="min-h-screen bg-ink text-cream">
                    <Navbar />
                    <main>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/committees" element={<Committees />} />
                            <Route path="/schedule" element={<Schedule />} />
                            <Route path="/gallery" element={<GalleryPage />} />
                        </Routes>
                    </main>
                    <Footer />
                </div>
                <div aria-hidden="true" className="grain-overlay" />
            </BrowserRouter>
        </MotionConfig>
    );
}

export default App;
